import styles from './PictoTextDescription.module.scss'
import { PictoTextDescriptionProps } from '@commons/picto-text-description/types.ts'
import { sanitizeHtml } from '@content/helpers/src/utils.ts'
import viewportHelpers from '@content/helpers/src/viewport.helpers.ts'

const PictoTextDescription = ({ items = [] }: PictoTextDescriptionProps) => {
    const hasImageOnly = items.some(block => {
        const hasTextContent = Boolean(
            block.heading || block.subtitle || block.description
        )
        return !hasTextContent
    })

    const getPictoUrl = (picto: {
        desktop?: { src?: string }
        retina?: { src?: string }
        mobile?: { src?: string }
    }): string => {
        if (!picto) return ''
        if (viewportHelpers.is.retina && picto.retina?.src)
            return picto.retina.src
        if (viewportHelpers.is.desktop && picto.desktop?.src)
            return picto.desktop.src
        return picto.mobile?.src || ''
    }

    return (
        <div
            className={`${styles.pictoTextDescription} ${
                hasImageOnly ? styles.pictoTextDescription__noText : ''
            }`}>
            {items.map((block, index) => {
                const hasTextContent = Boolean(
                    block.heading || block.subtitle || block.description
                )
                const isReferralPlaceholder =
                    typeof block.description === 'string' &&
                    block.description === 'referral_code'

                const hasText = hasTextContent && !isReferralPlaceholder

                const classes = [
                    styles.pictoTextDescription__block,
                    block.background
                        ? styles[
                              `pictoTextDescription__block--${block.background}${
                                  !hasText ? '--noText' : ''
                              }`
                          ]
                        : ''
                ].join(' ')

                return (
                    <div
                        className={classes}
                        key={index}
                        style={
                            block.picto
                                ? {
                                      backgroundImage: `url(${getPictoUrl(block.picto)})`
                                  }
                                : {}
                        }>
                        {hasText && (
                            <>
                                {block.heading && (
                                    <div
                                        className={
                                            styles.pictoTextDescription__block__title
                                        }>
                                        <h4>{block.heading}</h4>
                                    </div>
                                )}
                                {block.subtitle && (
                                    <h5>
                                        <span
                                            className={
                                                styles.pictoTextDescription__block__subtitle
                                            }>
                                            {block.subtitle}
                                        </span>
                                    </h5>
                                )}
                                {block.description && (
                                    <div
                                        className={
                                            styles.pictoTextDescription__block__description
                                        }>
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: sanitizeHtml(
                                                    block.description
                                                )
                                            }}
                                        />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                )
            })}
        </div>
    )
}

export default PictoTextDescription
